"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

var _flickityImagesloaded = _interopRequireDefault(require("flickity-imagesloaded"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Create a new carousel instance.
 * @param {String} selector - DOM selector.
 * @param {object} config - Flickity carousel settings.
 */


var _default = function _default(selector, config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    autoPlay: false,
    cellAlign: 'left',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * DOM node selectors.
   */

  var nodeSelectors = {
    container: document.querySelector(selector),
    cells: _toConsumableArray(document.querySelectorAll(config.cellSelector))
  };
  /**
   * Instance globals.
   */

  var carousel = {};
  /**
   * Loads only images of cells that are in screen view in the carousel & lazy loads the rest of the images
   * @param {HTMLElement} container - The carousel container
   * @param {HTMLElement} cells - The carousel cells
   */

  function imagesLazyLoadCount(container, cells) {
    var containerLength = container.offsetWidth;
    var cellWidth = cells[0].offsetWidth;

    if (containerLength > cellWidth) {
      return parseInt((containerLength / cellWidth - 2).toFixed(0), 10);
    }

    return true;
  }
  /**
   * Initialise carousel component.
   */


  function init() {
    if (nodeSelectors.cells.length <= 1) {
      return;
    }

    var imagesLoadCount = imagesLazyLoadCount(nodeSelectors.container, nodeSelectors.cells);
    carousel = new _flickityImagesloaded["default"](nodeSelectors.container, {
      autoPlay: settings.autoPlay,
      cellSelector: settings.cellSelector,
      cellAlign: settings.cellAlign,
      pageDots: settings.pageDots,
      prevNextButtons: settings.prevNextButtons,
      wrapAround: settings.wrapAround,
      imagesLoaded: settings.imagesLoaded,
      lazyLoad: imagesLoadCount,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 70,
        y2: 40,
        x3: 30
      }
    });
  }
  /**
   * Trigger reload events.
   */


  function reload() {
    carousel.reloadCells();
  }
  /**
   * Trigger resize events.
   */


  function resize() {
    carousel.resize();
  }
  /**
   * Destroy instance.
   */


  function destroy() {
    carousel.destroy();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init,
    reload: reload,
    resize: resize,
    destroy: destroy
  });
};

exports["default"] = _default;